
export const env: IEnvironment = {
	apiURL: 'https://app.norbec.com/modlr',
	name: 'production',
};
